module.exports = __webpack_public_path__ + "media/cards/virtual-card-image-0711841b.png";